import runner from "./core/runner.js";
export default (args => runner(args).catch(error => {
  setImmediate(() => {
    throw error;
  });
}));